import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { AppComponent } from './app.component';
import { HeaderComponent } from './main/header/header.component';
import { FooterComponent } from './main/footer/footer.component';
import { HomeComponent } from './main/home/home.component';
import { BannerComponent } from './main/banner/banner.component';
import { SidebarComponent } from './main/sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { BackendHost } from './_host/host';
import { DecimalPipe } from '@angular/common';
import { DateagoModule } from './main/dateago/dateago.module';
import { RecaptchaModule } from "ng-recaptcha";
const config: SocketIoConfig = {url: BackendHost ,options: {}};

@NgModule({
  declarations: [
    AppComponent,
    ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TabsModule.forRoot() ,
    CollapseModule.forRoot(),
    SocketIoModule.forRoot(config),
    HttpClientModule,
    RecaptchaModule,
    ToastrModule.forRoot({
      timeOut: 6000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      autoDismiss:true,
      maxOpened:1,
      progressBar: true
    }),
    DateagoModule
  ],
  providers: [DecimalPipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
